<template>

  <!-- Save Popup -->
  <van-popup
      class="single-edit-popup main-color"
      :value="value"
      @input="onShowChange"
      id="dropdown-menu-date"
      round
      :style="{ width: '80%',height:'410px' }"
      :close-on-click-overlay="false"
  >

    <div class="dropdown-menu-date flex flex-col ">
      <div class="flex flex-row items-center justify-between" style="font-weight: bold; font-size:24px">
        <div class="horizontal items-center ">
          <DropdownDate id="month" :options="monthActions" :active="changeMonth" :value="currentMonth"
              @input="onSelectMonth" @onshow="onShowMonth" />
          <DropdownDate id="year" class="ml-3" :options="yearActions" :active="!changeMonth" :value="currentYear"
              @input="onSelectYear" @onshow="onShowYear"/>
          <!--          <span @click="toggleDate(true)" style="width:80px"-->
          <!--              :class="changeMonth? 'main-color':'third-color' ">{{ currentMonthAbbreviations }}</span>-->
          <!--          <span @click="toggleDate(false)" class="year "-->
          <!--              :class="changeMonth? 'third-color': 'main-color'">{{ currentYear }}</span>-->

        </div>
        <div>
          <span @click="onClickPrevMonth"><</span>
          <span style="margin-left:32px" :class="disabledNextMonth ? 'disable-next-month':''"
              @click="onClickNextMonth">></span>
        </div>
      </div>
      <div class="weekend">
        <span style="width:30px" v-for="(item,index) in weekend" :key="index">{{ item }}</span>
      </div>
      <div class="grid grid-cols-7 text-center gap-3 mt-2.5" style="height:240px">
              <span v-for="(item,index) in dayOfMonth" :key="currentMonth + index"
                  :class="[item.active?'day-active' :'day', item.selected ? 'day-select': '']"
                  @click="onDayClick(item,index)">{{ item.day }}</span>
      </div>

      <div class="flex flex-row center-items justify-around mt-4 w-full">
        <div class="cancel-btn radius-border" @click="onCancel">Cancel</div>
        <div class="apply-btn" @click="onApply">Apply</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import log from "@/util/log";
import DropdownDate from "@/components/DropdownDate.vue";

export default {
  name: "PopupDate",
  components: { DropdownDate },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    initContent: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 10
    },
    currentSelectTime: {
      type: String,
      default: ""
    }
  },
  data() {
    return {

      value1: 0,
      value2: 'a',
      option1: [
        { text: '全部商品', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 },
      ],
      option2: [
        { text: '默认排序', value: 'a' },
        { text: '好评排序', value: 'b' },
        { text: '销量排序', value: 'c' },
      ],

      changeMonth: true,
      showPopup: false,
      content: "",
      weekend: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      monthsAbbreviations: [
        "Jan", // 一月
        "Feb", // 二月
        "Mar", // 三月
        "Apr", // 四月
        "May", // 五月
        "Jun", // 六月
        "Jul", // 七月
        "Aug", // 八月
        "Sep", // 九月
        "Oct", // 十月
        "Nov", // 十一月
        "Dec"  // 十二月
      ],
      monthActions: [
        { text: "Jan", value: 1, active: true },
        { text: "Feb", value: 2, active: true },
        { text: "Mar", value: 3, active: true },
        { text: "Apr", value: 4, active: true },
        { text: "May", value: 5, active: true },
        { text: "Jun", value: 6, active: true },
        { text: "Jul", value: 7, active: true },
        { text: "Aug", value: 8, active: true },
        { text: "Sep", value: 9, active: true },
        { text: "Oct", value: 10, active: true },
        { text: "Nov", value: 11, active: true },
        { text: "Dec", value: 12, active: true }
      ],
      yearActions: (() => {
        const today = new Date()
        const year = today.getFullYear()
        const years = []
        for (let i = 1900; i <= year; i++) {
          years.push({ text: `${i}`, value: i ,active:true})
        }
        return years;
      })(),
      currentMonth: "",
      currentYear: "",
      dayOfMonth: null,

      prevSelectIndex: -1,
      disabledNextMonth: true,
      showMonthPopup: false,
      showYearPopup: false,
      lockScroll: true
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.content = this.initContent;
      }
    },

    currentSelectTime(val) {

      const today = val ? new Date(val) : new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1; // JavaScript 中月份从0开始，所以要加1
      console.log(`currentMonth = ${currentMonth}`);

      this.dayOfMonth = this.generateDayOfMonth(currentYear, currentMonth);
      this.currentYear = currentYear;
      this.currentMonth = currentMonth;
      this.prevSelectIndex = this.dayOfMonth.findIndex(item => item.selected);

      this.disabledNextMonth = (new Date(this.currentYear, this.currentMonth, 1, 0, 0, 0).getTime() > new Date().getTime());
    }
  },
  computed: {
    currentMonthAbbreviations() {
      return this.monthsAbbreviations[this.currentMonth - 1];
    }
  },
  methods: {
    checkMonth() {
      const today = new Date()
      const month = today.getMonth()
      console.log(month)
      if (this.currentYear === today.getFullYear()) {
        this.monthActions.forEach((item,index)=> {
          if (index <= month) {
            item.active = true
          }else {
            item.active = false
          }
        })
      } else {
        this.monthActions = [
          { text: "Jan", value: 1, active: true },
          { text: "Feb", value: 2, active: true },
          { text: "Mar", value: 3, active: true },
          { text: "Apr", value: 4, active: true },
          { text: "May", value: 5, active: true },
          { text: "Jun", value: 6, active: true },
          { text: "Jul", value: 7, active: true },
          { text: "Aug", value: 8, active: true },
          { text: "Sep", value: 9, active: true },
          { text: "Oct", value: 10, active: true },
          { text: "Nov", value: 11, active: true },
          { text: "Dec", value: 12, active: true }
        ]
      }
    },
    onShowMonth() {
      this.changeMonth = true
      this.checkMonth()
    },
    onShowYear() {
      this.changeMonth = false
    },
    onSelectMonth(e, index) {
      console.log(e, index);
      this.currentMonth = e.value


      const nextDate = new Date(this.currentYear, this.currentMonth - 1);
      const currentDate = new Date();
      console.log(nextDate);
      if (nextDate > currentDate) {
        console.log(`超过了`);
        this.currentMonth = currentDate.getMonth() + 1;
      }
      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);
    },
    onSelectYear(e, index) {
      console.log(e, index);
      this.currentYear = e.value

      const nextDate = new Date(this.currentYear, this.currentMonth - 1);
      const currentDate = new Date();
      console.log(nextDate);
      if (nextDate > currentDate) {
        console.log(`超过了`);
        this.currentMonth = currentDate.getMonth() + 1;
      }
      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);
    },
    toggleDate(isMonth) {
      this.changeMonth = isMonth;
    },
    onShowChange(e) {
      this.$emit("input", e);
    },
    formatNumberToTwoDigits(number) {
      return number < 10 ? "0" + number : "" + number;
    },
    generateDayOfMonth(currentYear, currentMonth) {
      //接下来，我们需要确定当前月份有多少天，这可以通过创建下一个月的第0天来实现：
      const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
      // 获取当前月份的第一天是星期几
      const firstDayOfWeek = new Date(currentYear, currentMonth - 1, 1).getDay(); // JavaScript 中星期天是0
      // 生成当前月份的日期数组
      const dates = [];

      // 补全上个月的日期
      const lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;
      const lastYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const daysInLastMonth = new Date(lastYear, lastMonth, 0).getDate();

      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        dates.push({
          year: lastYear,
          month: lastMonth,
          day: daysInLastMonth - i
        });
      }

      const todayDate = new Date();
      const todayDay = todayDate.getDate();
      const todayYear = todayDate.getFullYear();
      const todayMonth = todayDate.getMonth();
      // 添加当前月份的日期
      for (let i = 1; i <= daysInMonth; i++) {
        const selected = this.currentSelectTime === `${currentYear}-${this.formatNumberToTwoDigits(currentMonth)}-${this.formatNumberToTwoDigits(i)}`;
        dates.push({
          year: currentYear,
          month: currentMonth,
          day: i,
          active: (todayYear === currentYear && todayMonth + 1 === currentMonth) ? (i <= todayDay) : true,
          selected: selected
        });
      }

      // 补全下个月的日期
      const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
      const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;
      const daysInNextMonth = 7 - (dates.length % 7);

      for (let i = 1; i <= daysInNextMonth; i++) {
        dates.push({
          year: nextYear,
          month: nextMonth,
          day: i
        });
      }
      return dates;
    },
    onDayClick(item, index) {
      if (!item.active) {
        return;
      }
      if (this.prevSelectIndex === index) {
        // this.prevSelectIndex = -1;
        // this.dayOfMonth[index].selected = false;
        return;
      }
      if (this.prevSelectIndex !== -1) {
        this.dayOfMonth[this.prevSelectIndex].selected = false;
        // this.$set(this.dayOfMonth, this.prevSelectIndex, { ...item, selected: false });
      }
      this.prevSelectIndex = index;
      this.dayOfMonth[index].selected = true;
    },
    onClickPrevMonth() {
      this.prevSelectIndex = -1;

      this.checkMonth()
      if (this.changeMonth) {
        this.currentMonth -= 1;
        if (this.currentMonth < 1) {
          this.currentMonth = 12;
          this.currentYear -= 1;
        }
      } else {
        this.currentYear -= 1;
      }


      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);
      this.disabledNextMonth = false;
    },
    onClickNextMonth() {
      this.prevSelectIndex = -1;
      if (this.disabledNextMonth) {
        return;
      }

      this.checkMonth()
      if (this.changeMonth) {
        this.currentMonth += 1;
        if (this.currentMonth > 12) {
          this.currentMonth = 1;
          this.currentYear += 1;
        }
      } else {
        this.currentYear += 1;
        const nextDate = new Date(this.currentYear, this.currentMonth - 1);
        const currentDate = new Date();
        console.log(nextDate);
        if (nextDate > currentDate) {
          console.log(`超过了`);
          this.currentMonth = currentDate.getMonth() + 1;
        }

      }

      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);

      const currentDate = new Date();
      currentDate.setDate(1);
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setMinutes(0);
      if (new Date(this.currentYear, this.currentMonth, 1, 0, 0, 0) > currentDate) {
        this.disabledNextMonth = true;
      }
    },
    onCancel() {
      this.$emit("onCancel");
    },
    onApply() {
      const findSelected = this.dayOfMonth.filter(item => item.selected);
      if (findSelected.length === 0) {
        this.$emit("onApply", "");
        return;
      }
      this.$emit("onApply", findSelected[0]);
    }
  },
  mounted() {
    this.showPopup = this.show;
    this.content = this.initContent;
    const today = this.currentSelectTime ? new Date(this.currentSelectTime) : new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // JavaScript 中月份从0开始，所以要加1
    console.log(`currentMonth = ${currentMonth}`);

    this.dayOfMonth = this.generateDayOfMonth(currentYear, currentMonth);
    this.currentYear = currentYear;
    this.currentMonth = currentMonth;
    this.prevSelectIndex = this.dayOfMonth.findIndex(item => item.selected);


    this.disabledNextMonth = (new Date(this.currentYear, this.currentMonth, 1, 0, 0, 0).getTime() > new Date().getTime());
  }
};
</script>


<style scoped lang="less">

.single-edit-popup {
  font-size: 16px;
  padding: 16px;
  text-align: center;

  & > * + * {
    margin-top: 16px;
  }

  .single-edit-title {
    font-size: 20px;
    text-align: center;
    width: 100%;
  }

  .single-edit-content {
    padding: 15px 23px 20px 23px;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .single-edit-msg {

  }

  .input {
    width: 100%;
    padding: 0 16px;
  }

  .footer {
    display: flex;
    align-items: center;

    .footer-cancel {
      margin-top: 16px;
      margin-right: 5px;
      width: 100%;
      height: 40px;
      font-weight: normal;
      color: #333333;
    }

    .footer-confirm {
      margin-top: 16px;
      margin-left: 5px;
      height: 40px;
      color: #ffffff;
      background: var(--themeMainColor);
      width: 100%;
      font-weight: normal;
    }
  }
}


.month {
  font-weight: bold;
  font-size: 24px
}

.year {
  font-weight: bold;
  font-size: 24px;
  margin-left: 16px;
}

.day-item {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 21px;
  color: #BDBDBD;
}

.weekend {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 21px;
  font-weight: bold;
}

.day-select {
  background: #333333 !important;
  color: white !important;
  pointer-events: unset;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.day-active {
  background: white;
  color: #333333;
  width: 30px;
  height: 30px;
  pointer-events: unset;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.day {
  background: white;
  color: #BDBDBD;
  width: 30px;
  height: 30px;
  pointer-events: unset;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-btn {
  width: 99px;
  height: 34px;
  color: #333333;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apply-btn {
  width: 99px;
  height: 34px;
  background: #333333;
  color: white;
  border-radius: 12px;
  line-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disable-next-month {
  color: #e8e8e8;
}

::v-deep .van-popover__arrow {
  border-width: 0px;
}

::v-deep .van-popover__content {
  padding: 0;
  font-size: 16px;
  overflow-y: scroll;
}

::v-deep .van-popover {
  overflow-y: scroll !important;
}

.month-year-item {
  width: 80px;
  height: 280px;
  background-color: #f6f6f6;
}

</style>